// 健康平衡度模块
// 仪表盘绘制由 Balance/index.vue 在 mounted / watch 中调用 chart.drawMeter
export default function transform(/* data */) {
    // no-op
}
